import { FC } from 'react';
import { useAppDrawer } from '../../../../../AppDrawer/AppDrawerProvider';
import InvestigationDrawer from '../../../../../InvestigationDrawer/InvestigationDrawer';
import { Badge, DefaultCell, IconButton, IconButtonSizes, IconButtonStyles, Icons } from '@silverfort/sf-components';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { TableRow } from '../../types';
import {
    PROTECTED_ENTITY_BADGE_PROPS,
    UNPROTECTED_ENTITY_BADGE_PROPS
} from '../../../../../../modules/universalMFA/consts';

type Props = TableRow;

const NameCell: FC<Props> = ({ guid, name, metadata = {} }) => {
    const { displayContent } = useAppDrawer();
    const { isProtected, adType } = metadata;

    const handleInvestigationClick = () => {
        displayContent(<InvestigationDrawer guid={guid} adType={adType ?? AD_ENTITY_TYPES.USER} />);
    };

    return (
        <div className="flex items-center justify-between gap-2">
            <div className="flex-1 overflow-hidden">
                <DefaultCell text={name} />
            </div>
            <div
                className={`flex items-center gap-2 ${
                    isProtected === undefined ? 'w-fit justify-end' : 'w-[114px] justify-between'
                }`}>
                {isProtected !== undefined && (
                    <Badge {...(isProtected ? PROTECTED_ENTITY_BADGE_PROPS : UNPROTECTED_ENTITY_BADGE_PROPS)} />
                )}
                <IconButton
                    className="opacity-0 group-hover:opacity-100"
                    sizeVariant={IconButtonSizes.Large}
                    buttonStyle={IconButtonStyles.Secondary}
                    iconSize={20}
                    icon={Icons.Investigate}
                    onClick={handleInvestigationClick}
                />
            </div>
        </div>
    );
};

export default NameCell;
